import { AxiosError, isAxiosError } from 'axios';
import { IApiErrorRes, IApiErrorParams } from '../apiError.interface';

export const isApiError = <T extends IApiErrorParams>(error: unknown): error is AxiosError<IApiErrorRes<T>> => {
  return isAxiosError<IApiErrorRes<T>>(error);
};
